import $ from 'jquery';

$.template = name => {
  return (window.pug_templates || {})[name];
};

$.render = (name, ...params) => {
  const tmpl = $.template(name);

  if (!tmpl) throw new Error(`Unable to find template '${name}'`);

  return tmpl.apply(window, params);
};

$.fn.render = function (name, ...params) {
  $(this).html($.render(name, ...params));
  return this;
};

$.renderItem = function (name, item, ...params) {
  return $($.render(name, item, ...params))
    .data('item', item)
    .initUI();
};

$.fn.renderItem = function (name, item, ...params) {
  const $item = $.renderItem(name, item, ...params);

  $(this).replaceWith($item);
  return $item;
};
